<template>
    <div class="industry_info">
        <div class="bread_crumbs">
            <RouterLink :to="{name: 'index'}">首页</RouterLink>>
            <RouterLink v-if="this.$route.query.navtype == 1" :to="{name: 'IndustryInformation', query: {bannerID: 6}}">行业信息</RouterLink>
            <RouterLink v-if="this.$route.query.navtype == 2" class="case" :to="{name: 'CooperationCase', query: {bannerID: 7}}">合作案例</RouterLink>
            <i v-if="this.$route.query.navtype == 1">></i>
            <span v-if="this.$route.query.navtype == 1">{{ $route.query.typeName }}</span>
        </div>
        <div class="article">
            <h2>{{ article.xName }}</h2>
            <div v-if="this.$route.query.navtype == 1" class="source">
                <span>来源：{{ article.source }}</span> <span>时间：{{ article.showTime }}</span>
            </div>
            <div v-if="$route.query.navtype == 1" class="content" v-html="article.content" />
            <div v-else class="content" v-html="article.xContent" />
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            article: {}
        }
    },
    mounted() {
        if (this.$route.query.navtype == 1) {
            this.getNewsInfo()
        } else {
            this.getCaseInfo()
        }
    },
    methods: {
        getNewsInfo() {
            this.$api.get('news/xInfo', {
                params: {
                    xId: this.$route.query.id
                }
            }).then(res => {
                this.article = res.data
            })
        },
        getCaseInfo() {
            this.$api.get('CooperationCase/xInfo', {
                params: {
                    xId: this.$route.query.id
                }
            }).then(res => {
                this.article = res.data
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.industry_info {
    width: 100%;
    background: rgba(238, 238, 238, 1);
    padding-bottom: 50px;
    .bread_crumbs {
        width: 1200px;
        height: 62px;
        line-height: 62px;
        margin: 0 auto;
        background: transparent;
        font-size: 14px;
        font-weight: 400;
        color: rgba(102, 102, 102, 1);
        a {
            margin-right: 10px;
            margin-left: 10px;
            color: rgba(102, 102, 102, 1);
            &:first-child {
                margin-left: 0;
            }
        }
        .case {
            color: rgba(221, 34, 38, 1);
        }
        span {
            color: rgba(221, 34, 38, 1);
            margin-left: 10px;
        }
    }
    .article {
        width: 1200px;
        padding: 84px 170px 164px 170px;
        background: rgba(255, 255, 255, 1);
        box-sizing: border-box;
        margin: 0 auto;
        h2 {
            text-align: center;
            font-size: 36px;
            font-weight: 400;
            color: rgba(51, 51, 51, 1);
            margin-bottom: 30px;
        }
        .source {
            font-size: 14px;
            font-weight: 400;
            color: rgba(153, 153, 153, 1);
            text-align: center;
            margin-bottom: 60px;
            span {
                margin-right: 20px;
            }
        }
        .content {
            font-size: 16px;
            font-weight: 400;
            color: rgba(102, 102, 102, 1);
            line-height: 28px;
            margin-bottom: 30px;
        }
        .infoImg {
            margin-top: 60px;
            img {
                width: 860px;
            }
        }
    }
}
</style>
